import { storeCreator } from '@/utils/store/store.utils';

import { FundPayload } from '../../SelfDirected.types';

interface State {
  funds: FundPayload[];
  setFunds: (values: FundPayload[]) => void;
  pushFunds: (values: FundPayload[]) => void;
  removeHighlight: () => void;
  reset: () => void;
}

const useStore = storeCreator<State>((set) => ({
  funds: [],
  setFunds: (values: FundPayload[]) =>
    set(() => ({
      funds: values,
    })),
  pushFunds: (values: FundPayload[]) =>
    set((state) => ({
      funds: [...state.funds, ...values],
    })),
  removeHighlight: () =>
    set((state) => ({
      funds: state.funds.map((item) => ({
        ...item,
        isHighlighted: false,
      }))
    })),
  reset: () =>
    set(() => ({
      funds: [],
    })),
}));

export default useStore;
